import { usePlatform } from "components/utils/PlatformContext";

interface LandingPageBackgroundProps {
  children?: React.ReactNode;
}

const LandingPageBackground: React.FC<LandingPageBackgroundProps> = ({children}) => {
  // Get the platform context
  const { loginBackground } = usePlatform();
  
  return (
    <div className="w-full h-full min-h-screen flex relative">
      <img
        className="fixed min-w-[1436px] min-h-[900px] w-full h-screen size-full flex z-0 resize-none"
        src={loginBackground}
        alt="Background login image"
      />
      {children}
    </div>
  );
};

export default LandingPageBackground;
